import axios from 'axios';
import { BASE_URL } from '../ApiService/ApiConfig.js';

/** Servicio del Dashboard de Alarmas GPS. Lee los endpoints dash_gps. */
export class DashboardGpsService {

    _cfg() {
        const jwt = (localStorage.getItem('jwt') || '').replace(/"/g, '');
        return { headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + jwt } };
    }

    async cortes() {
        const res = await axios.get(`${BASE_URL}/dashboard-gps/cortes`, this._cfg());
        return res.data;
    }

    async dashboard(corteId, grupos, empresas, tipos, dia, rutas, placas, familias) {
        const p = new URLSearchParams();
        p.append('corteId', corteId);
        if (grupos && grupos.length) p.append('grupos', grupos.join(','));
        if (empresas && empresas.length) p.append('empresas', empresas.join(','));
        if (tipos && tipos.length) p.append('tipos', tipos.join(','));
        if (dia != null) p.append('dia', dia);
        if (rutas && rutas.length) p.append('rutas', rutas.join(','));
        if (placas && placas.length) p.append('placas', placas.join(','));
        if (familias && familias.length) p.append('familias', familias.join(','));
        const res = await axios.get(`${BASE_URL}/dashboard-gps/dashboard?${p.toString()}`, this._cfg());
        return res.data;
    }

    /** Recorrido real (traza GPS) + alarmas de un vehiculo en el corte. */
    async trayectoria(corteId, placa) {
        const p = new URLSearchParams();
        p.append('corteId', corteId);
        p.append('placa', placa);
        const res = await axios.get(`${BASE_URL}/dashboard-gps/trayectoria?${p.toString()}`, this._cfg());
        return res.data;
    }

    /** Dispara un corte (dev / admin). modo = 'muestra' | 'completo'. desde/hasta = 'yyyy-MM-dd' opcional. */
    async generarCorte(modo, desde, hasta) {
        const p = new URLSearchParams();
        p.append('modo', modo || 'muestra');
        if (desde) p.append('desde', desde);
        if (hasta) p.append('hasta', hasta);
        const res = await axios.post(`${BASE_URL}/dashboard-gps/corte?${p.toString()}`, {}, this._cfg());
        return res.data;
    }
}
